export function storyMatchesType(story, type) {
	if (!type || type === 'All') return true;
	if (story?.data?.type === type) return true;
	return Array.isArray(story?.data?.types) && story.data.types.some((item) => item.type === type);
}

export function isOnAirFestStory(story) {
	return storyMatchesType(story, 'On Air Fest');
}

export function isNotRelatedToEventsStory(story) {
	return !story?.data?.related_event?.id || isOnAirFestStory(story);
}
